
// Messages JSON files
import enTexts from "./en/index";

export const strings = enTexts;
